// extracted by mini-css-extract-plugin
module.exports = {"closeAlertButton":"EGiftCard_closeAlertButton__1d4q9","imageUploader":"EGiftCard_imageUploader__1AozZ"};